import { useAnalyticsSubscribe } from 'js/app/hooks/analiticsSubscribe';
import { useAllPlayerTags } from 'js/app/hooks/user/hooks/useAllPlayerTags';
import { useSetIsUserVerified } from 'js/app/hooks/user/hooks/useIsUserVerified';
import { useStoreQueryParam } from '@interlayer/js/app/hooks/useStoreQueryParam';
import { useSetUTMCookie } from 'js/components/system/App/buzz/hooks/useSetUTMCookie';
import { useRefereeCookie } from 'js/components/system/App/buzz/hooks/useRefereeCookie';
import { useSetUpdatedBalance } from 'js/components/system/App/buzz/hooks/useSetUpdatedBalance';
import { useSaveServerTime } from '@interlayer/js/app/hooks/useServerTime/useServerTime.js';
import { useRecentlyGames } from 'js/app/components/main/Games/hooks/useRecentlyGames/useRecentlyGames';
import { useManageInboxWidget } from '@interlayer/js/components/system/App/buzz/hooks/useManageInboxWidget';
import { useListenShowLoginPopup } from 'js/components/popups/LoginPopup/buzz/hooks/useListenShowLoginPopup';
import {
    useListenShowUpgradeMemberPopup
} from '@interlayer/js/app/components/main/Registration/components/popup/UpgradeMemberPopup/hooks/useListenShowUpgradeMemberPopup';
import { useAnalyticEvents } from '@interlayer/js/components/system/App/buzz/hooks/useAnalyticEvents';

export const useAfterInitHooks = () => {
    useRefereeCookie();
    useSetUTMCookie();
    useRecentlyGames();
    useStoreQueryParam();
    useSetIsUserVerified();
    useSetUpdatedBalance();
    useSaveServerTime();
    useAnalyticsSubscribe();
    useListenShowLoginPopup();
    useListenShowUpgradeMemberPopup();
    useAllPlayerTags({ isInitFetch: true });
    useManageInboxWidget();
    useAnalyticEvents();
};
